module.exports = __webpack_public_path__ + "static/media/whatsapp-white.80a15f3d.svg";